import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";

export interface LoginPromptState {
  isVisible: boolean;
  message: string;
  returnUrl: string | null;
}

@Injectable({
  providedIn: "root",
})
export class LoginPromptService {
  private state = new BehaviorSubject<LoginPromptState>({
    isVisible: false,
    message: "",
    returnUrl: null,
  });

  public state$ = this.state.asObservable();

  constructor(private router: Router) {}

  show(
    message: string = "Please log in to access this feature",
    returnUrl: string | null = null
  ) {
    this.state.next({
      isVisible: true,
      message,
      returnUrl: returnUrl || this.router.url,
    });
  }

  close() {
    this.state.next({
      isVisible: false,
      message: "",
      returnUrl: null,
    });
  }

  goToLogin() {
    const returnUrl = this.state.value.returnUrl;
    this.close();
    this.router.navigate(["/login"], {
      queryParams: returnUrl ? { returnUrl } : {},
    });
  }

  goToRegister() {
    const returnUrl = this.state.value.returnUrl;
    this.close();
    this.router.navigate(["/register"], {
      queryParams: returnUrl ? { returnUrl } : {},
    });
  }

  continueBrowsing() {
    this.close();
  }
}
